import FeatureGates, { type Identifiers } from '@atlaskit/feature-gate-js-client';
import { logException } from '@atlassian/atlassian-studio-observability';

import { featureGatesOptions } from '../use-initialise-feature-gates-client';

export async function updateUser({
	atlassianAccountId,
	atlassianOrgId,
	tenantId,
	workspaceId,
}: {
	atlassianAccountId: string;
	atlassianOrgId?: string;
	workspaceId?: string;
	tenantId?: string;
}): Promise<void> {
	const identifiers: Identifiers = {
		atlassianAccountId,
	};
	if (atlassianOrgId) {
		identifiers.atlassianOrgId = atlassianOrgId;
	}
	if (tenantId) {
		identifiers.tenantId = tenantId;
	}
	if (workspaceId) {
		// @NOTE: we dont yet have the `studioWorkspaceId` identifier setup in @atlaskit/feature-gate-js-client and statsig
		// so for now we will do the same as the studio BE and use `miscellaneousId`
		// https://atlassian.slack.com/archives/C04PR2YE4UC/p1754525667830779
		identifiers.miscellaneousId = workspaceId;
	}

	try {
		await FeatureGates.updateUser(featureGatesOptions, identifiers);
	} catch (error) {
		logException(error, {
			identifiers,
			tag: 'FeatureGates.updateUser',
		});
	}
}
